import ApiService from '@/api/ApiService';
import { TRole } from '@/types/roles'

class RolesRepository extends ApiService {
  constructor() {
    super('/roles');
  }

  async getRoles() {
    const response = await this.get<{ roles: Array }>(
      '',
    );
    return response.roles;
  }

  async getRolesPermissions() {
    const response = await this.get<{ permissions: Array }>(
      '/permissions',
    );
    return response.permissions;
  }

  async addRole(role: TRole) {
    await this.post('', role);
  }

  async removeRole(role: TRole) {
    await this.delete(`/${role.id}`);
  }

  async updateRole(role: TRole) {
    await this.patch(`/${role.id}`, role);
    await this.patch(`/${role.id}/permissions`, role);
  }
}

export default new RolesRepository();